import api from "@/libs/axios";
import { PaginatedList } from "../models/common/paginatedList";
import {
  ProjetListItem, ProjetDetail, ProjetRef,
  CreateProjetModel, UpdateProjetModel,
} from "../models/projets/projet";

// Projets d'amélioration continue (regroupement de chantiers). Distinct du ProjetsResource existant
// (projets d'actions collectives rattachés aux entreprises) : endpoint dédié /projets.
const resource = "projets";

export interface ProjetsChantierSearchParams {
  pageNumber?: number; pageSize?: number;
  search?: string;
  orderBy?: string; orderByDescending?: boolean;
}

export default class ChantierProjetsResource {
  async search(params: ProjetsChantierSearchParams): Promise<PaginatedList<ProjetListItem>> {
    const response = await api.get(`${resource}`, { params });
    return response.data;
  }
  // Liste légère (id, nom) pour le sélecteur « Projet » du formulaire chantier.
  async listRef(): Promise<ProjetRef[]> {
    return (await api.get(`${resource}/ref`)).data;
  }
  async getById(id: string): Promise<ProjetDetail> {
    return (await api.get(`${resource}/${id}`)).data;
  }
  // Récap PDF de synthèse du projet (blob).
  async downloadRecapPdf(id: string): Promise<Blob> {
    return (await api.get(`${resource}/${id}/recap-pdf`, { responseType: "blob" })).data;
  }
  async create(data: CreateProjetModel): Promise<string> {
    return (await api.post(`${resource}`, data)).data;
  }
  async update(id: string, data: UpdateProjetModel): Promise<string> {
    return (await api.put(`${resource}/${id}`, data)).data;
  }
  async delete(id: string): Promise<void> {
    await api.delete(`${resource}/${id}`);
  }
  // Remplace l'ensemble des chantiers rattachés au projet (gestion depuis la page projet).
  async setChantiers(id: string, chantierIds: string[]): Promise<string> {
    return (await api.put(`${resource}/${id}/chantiers`, { chantierIds })).data;
  }
}
